(function () {
  'use strict';

  function readConfig() {
    var el = document.getElementById('google-store-widget-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function cleanConfig(raw) {
    if (!raw || typeof raw !== 'object') return {};
    var cfg = {};
    if (raw.position === 'LEFT_BOTTOM' || raw.position === 'RIGHT_BOTTOM') {
      cfg.position = raw.position;
    }
    if (raw.region) cfg.region = String(raw.region).toUpperCase();
    if (raw.merchant_id) cfg.merchant_id = String(raw.merchant_id).trim();
    cfg.sideMargin = 24;
    cfg.bottomMargin = 4;
    ['mobileSideMargin', 'mobileBottomMargin'].forEach(function (key) {
      var n = Number(raw[key]);
      if (!isNaN(n)) cfg[key] = n;
    });
    return cfg;
  }

  var PHONE_MQ = '(max-width: 767px)';

  function isPhoneViewport() {
    return window.matchMedia && window.matchMedia(PHONE_MQ).matches;
  }

  function widgetEl() {
    return (
      document.getElementById('google-merchantwidget-iframe-wrapper') ||
      document.getElementById('merchantwidgetiframe')
    );
  }

  function pinWidget() {
    if (isPhoneViewport()) return;
    var el = widgetEl();
    if (!el) return;
    el.style.setProperty('left', '24px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    var sticky = document.querySelector('[data-sticky-atc]');
    var stickyOn = !!(
      sticky &&
      !sticky.hidden &&
      (document.body.classList.contains('pdp-sticky-on') || sticky.offsetHeight > 0) &&
      sticky.getClientRects().length
    );
    var bottom = 4;
    if (stickyOn) {
      bottom = Math.round(sticky.getBoundingClientRect().height) + 18;
    }
    el.style.setProperty('bottom', bottom + 'px', 'important');
  }

  function startWidget(cfg) {
    if (isPhoneViewport()) return;
    if (!window.merchantwidget || typeof window.merchantwidget.start !== 'function') return;
    if (!document.getElementById('google-merchantwidget-iframe-wrapper')) {
      try {
        window.merchantwidget.start(cfg);
      } catch (err) {
        // Embed may already have started the iframe — still pin it.
      }
    }
    pinWidget();
  }

  function googleAppEmbedPresent() {
    var existing = document.getElementById('merchantWidgetScript');
    return !!(existing && existing.getAttribute('data-gsw') !== '1');
  }

  function loadScript(cfg) {
    var existing = document.getElementById('merchantWidgetScript');
    if (existing) {
      if (window.merchantwidget) startWidget(cfg);
      else existing.addEventListener('load', function () { startWidget(cfg); });
      pinWidget();
      return;
    }
    if (googleAppEmbedPresent()) {
      pinWidget();
      return;
    }
    var script = document.createElement('script');
    script.id = 'merchantWidgetScript';
    script.setAttribute('data-gsw', '1');
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.defer = true;
    script.addEventListener('load', function () {
      startWidget(cfg);
    });
    document.head.appendChild(script);
  }

  var raw = readConfig();
  if (!raw) return;
  loadScript(cleanConfig(raw));

  var mo = new MutationObserver(pinWidget);
  mo.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  window.addEventListener('resize', pinWidget, { passive: true });
  window.addEventListener('load', pinWidget);
  setTimeout(pinWidget, 800);
  setTimeout(pinWidget, 2000);
})();
